export enum FeedbackType {
  NO_FEEDBACK,
  CREATE_SUCCESS,
  CREATE_FAIL,
  UPDATE_SUCCESS,
  UPDATE_FAIL,
  ERROR,
}

export interface IState {
  message: string
  feedbackType: FeedbackType
  time: number | undefined
  isVisible: boolean
}
